const state = {
  isLoading: true,
}

const mutations = {
  show(state) {
    state.isLoading = true

  },
  hide(state) {
    state.isLoading = false
  },
}

const actions = {


}

const getters = {
  getIsLoading: state => ()=> state.isLoading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
